import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import { Layout } from 'antd';

import CabinetHeader from '../../../../components/Header';

import API from '../../../../helpers/api';
import { setIframeQuery } from '../../../../helpers/iframe';

import { useTheme } from '../../../../context/Theme';

const { Content } = Layout;

const DOCUMENTATION_BASE_PATH = '/docs-ai/documentation';
const DEFAULT_DOCUMENTATION_PATH = 'category1/Article%201';

const getDocumentationPathFromHash = (hash: string): string => {
  const path = hash.replace(/^#\/?/, '').trim();

  if (!path) {
    return DEFAULT_DOCUMENTATION_PATH;
  }

  if (path.includes('://') || path.startsWith('//')) {
    return DEFAULT_DOCUMENTATION_PATH;
  }

  return path;
};

const buildDocumentationIframeUrl = (
  path: string,
  lang: string,
  themeType: 'light' | 'dark'
): string => {
  const normalizedPath = path.replace(/^\/+/, '');
  const origin = API.getLocation()?.origin || '';
  const url = new URL(
    `${DOCUMENTATION_BASE_PATH}/${normalizedPath}`,
    origin || 'https://docs.mt7docs.com'
  );
  setIframeQuery(url, lang, themeType);

  return origin ? url.toString() : `${url.pathname}${url.search}`;
};

const DocumentationPage = () => {
  const intl = useIntl();
  const { theme } = useTheme();
  const location = useLocation();
  const [hash, setHash] = useState('');

  useEffect(() => {
    setHash(location.hash);
  }, [location.hash]);

  const iframeSrc = useMemo(
    () =>
      buildDocumentationIframeUrl(
        getDocumentationPathFromHash(hash),
        intl.locale,
        theme
      ),
    [hash, intl.locale, theme]
  );
  return (
    <Layout className="documentation-page">
      <CabinetHeader />
      <Content className="documentation-page__content">
        <iframe
          className="documentation-page__iframe"
          src={iframeSrc}
          title="Documentation"
        />
      </Content>
    </Layout>
  );
};

export default DocumentationPage;
